<template>
  <table v-if="list.board_name">
    <tr>
      <td
        :colspan="
          list.children_boards !== undefined
            ? list.children_boards.data[0].length * 2
            : 1
        "
        :class="{
          parentLevel: list.children_boards !== undefined,
          extend: list.children_boards !== undefined && list.extend
        }"
      >
        <div :class="{ node: true }">
          <div @click="$emit('click-node', list)">
            <board-item :board="list" :version="3" />
          </div>
        </div>
        <div
          class="extend_handle"
          v-show="addBoard"
          @click="
            $router.push({
              name: 'board.new-distribution-board-page',
              params: {
                id: $route.params.id, // Site ID
                name: $route.params.name, // Site name
                parentId: list.board_id, // DB Parent ID
                topMostParentId: mainBoardId // Main SW ID
              }
            })
          "
        >
          <b-icon
            variant="primary"
            icon="plus-circle-fill"
            scale="1.5"
          ></b-icon>
        </div>
      </td>
    </tr>
    <tr v-if="list.children_boards !== undefined && list.extend">
      <td
        v-for="(children_boards, index) in list.children_boards.data[0]"
        :key="index"
        colspan="2"
        class="childLevel"
      >
        <site-tree
          :json="children_boards"
          :main-board-id="mainBoardId"
          @click-node="$emit('click-node', $event)"
        />
      </td>
    </tr>
  </table>
</template>

<script>
import BoardItem from '@/components/cards/BoardItem'

export default {
  name: 'SiteTree',

  components: {
    BoardItem
  },

  props: ['json', 'mainBoardId'],

  data() {
    return {
      addBoard: false,
      list: {}
    }
  },

  watch: {
    json: {
      handler: function(Props) {
        let extendKey = function(jsonData) {
          jsonData.extend =
            jsonData.extend === void 0 ? true : !!jsonData.extend
          if (jsonData.children_boards !== undefined) {
            jsonData.children_boards.data[0].forEach(c => {
              extendKey(c)
            })
          }
          return jsonData
        }
        if (Props) {
          this.list = extendKey(Props)
        }
      },
      immediate: true
    }
  },

  methods: {
    toggleExtend: function(list) {
      list.extend = !list.extend
      this.$forceUpdate()
    }
  },

  created() {
    this.$root.$on('showPlusSign', flag => {
      this.addBoard = flag
    })
  }
}
</script>

<style scoped>
table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
td {
  position: relative;
  vertical-align: top;
  padding: 0 0 40px 0;
  text-align: center;
}
.extend_handle {
  position: absolute;
  left: 50%;
  margin-left: -6px;
  margin-top: -12px;
  cursor: pointer;
  z-index: 1;
  background-color: white;
}
/* .extend_handle:before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  border: 5px solid;
  border-color: #959595 #959595 transparent transparent;
  transform: rotateZ(135deg);
  transform-origin: 50% 50% 0;
  transition: transform ease 300ms;
}
.extend_handle:hover:before {
  border-color: #333 #333 transparent transparent;
}
.extend .extend_handle:before {
  transform: rotateZ(-45deg);
} */
.extend::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 15px;
  height: 25px;
  border-left: 5px solid #959595;
  transform: translate3d(-1px, 0, 0);
}
.childLevel::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 100%;
  height: 20px;
  border-left: 5px solid #959595;
  transform: translate3d(-1px, 0, 0);
  top: -10px;
}
.childLevel::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -15px;
  border-top: 5px solid #959595;
}
.childLevel:first-child:before,
.childLevel:last-child:before {
  display: none;
}
.childLevel:first-child:after {
  left: 50%;
  height: 30px;
  border: 5px solid;
  border-color: #959595 transparent transparent #959595;
  transform: translate3d(4px, 0, 0);
}
.childLevel:last-child:after {
  right: 50%;
  height: 30px;
  border: 5px solid;
  border-color: #959595 #959595 transparent transparent;
  transform: translate3d(-4px, 0, 0);
}
.childLevel:first-child.childLevel:last-child::after {
  left: auto;
  border-color: transparent #959595 transparent transparent;
  transform: translate3d(4px, 0, 0);
  height: 35px;
  margin-top: -5px;
}
.node {
  position: relative;
  display: inline-block;
  margin: 0 1em;
  box-sizing: border-box;
  text-align: left;
  min-width: 220px;
  margin-top: 10px;
}
.node.hasMate::after {
  content: '';
  position: absolute;
  left: 2em;
  right: 2em;
  top: 2em;
  border-top: 5px solid #959595;
  z-index: 1;
}
</style>
